<template>
	<v-container>
		<v-row>
			<v-col cols="8">
				<download-settlement-report-table />
			</v-col>
			<v-col cols="4">
				<settlement-report-upload />
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="8">
				<archived-adyen-settlement-reports />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>

export default {
	name: 'SettlementReportOverview',
};
</script>
